import { ResultOf } from "gql.tada";
import { GetCreativeSpecsPageById } from "@queries/archetypes/GetCreativeSpecsPageById";
import { TitleSection } from "@components/entries/TitleSection";
import { FAQSection } from "@components/entries/FaqSection";

type CreativeSpecsPageData = NonNullable<
  ResultOf<typeof GetCreativeSpecsPageById>["creativeSpecsPage"]
>;

export const CreativeSpecsPageRenderer = ({ data }: { data: CreativeSpecsPageData }) => {
  return (
    <>
      {data.titleSection && (
        <TitleSection entry={{ titleSection: data.titleSection } as any} />
      )}
      {data.faq && (
        <FAQSection entry={{ faqSection: data.faq } as any} />
      )}
    </>
  );
};
